export default __webpack_public_path__ + "static/media/landingHero@2x.8e20d17d.png";